import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { Box, Button, Card, Grid, Icon, Link, Modal, Progress, Text } from "~/components-shared";
import styled, { useTheme } from "styled-components";
import { Chart } from "react-chartjs-2";
import memberInsights from "~/charts/memberInsights";
import { helpers } from "~/lib/helpers";
import { BarController, BarElement, CategoryScale, Chart as ChartJs, LinearScale, LineController, LineElement, Tooltip } from "chart.js";
ChartJs.register(BarController, CategoryScale, LinearScale, BarElement, Tooltip, LineElement, LineController);
const InfoButton = styled(Button)`
  position: absolute;
  top: 1rem;
  right: 1rem;
`;
const StyledLink = styled(Link)`
  overflow: hidden;
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
const RepositoriesCard = _ref => {
  let {
    dateFrom,
    dateTo,
    widget,
    ...rest
  } = _ref;
  const {
    total,
    byDay,
    repositories
  } = widget.data;
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const totalSum = total.commitsPushed + total.prComments + total.prsCreated + total.prsReviewed + total.prsMerged;
  const [currPeriod, prevPeriod] = helpers.humanReadablePeriodDiff(dateFrom, dateTo);
  const handleClick = url => {
    window.open(url, "_blank");
  };
  const cardItem = repository => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledLink, {
      color: "text",
      onClick: () => handleClick(repository.url),
      fontSize: 4
    }, repository.name), /*#__PURE__*/React.createElement(Progress, {
      values: [repository.commitsPushed / (totalSum || 1) * 100, repository.prsCreated / (totalSum || 1) * 100, repository.prComments / (totalSum || 1) * 100, repository.prsReviewed / (totalSum || 1) * 100, repository.prsMerged / (totalSum || 1) * 100],
      height: 2,
      labels: [`Commited: ${repository.commitsPushed}`, `Created PRs: ${repository.prsCreated}`, `PR Comments: ${repository.prComments}`, `PRs Reviewed: ${repository.prsReviewed}`, `PRs Merged: ${repository.prsMerged}`],
      colors: ["#9fadbc", "#85b8ff", "#A0D7E7", "#d293eb", "#7de2b8"]
    }), /*#__PURE__*/React.createElement(Text, {
      color: "textSecondary",
      fontSize: 3
    }, repository.total));
  };
  return /*#__PURE__*/React.createElement(Card, rest, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    fontSize: 8,
    s: {
      mb: 0
    }
  }, "Repositories"), /*#__PURE__*/React.createElement(Box, {
    style: {
      height: "100px"
    },
    s: {
      mb: 1
    }
  }, /*#__PURE__*/React.createElement(Chart, _extends({
    id: "chart-js"
  }, memberInsights.repositoryDistribution(theme, byDay, currPeriod, prevPeriod)))), /*#__PURE__*/React.createElement(Grid, {
    cols: 3,
    template: "minmax(140px, auto) minmax(100px, 100%) 1rem",
    align: "center",
    gap: 3
  }, /*#__PURE__*/React.createElement(Link, {
    color: "text",
    fontSize: 4,
    weight: "semiBold"
  }, "Total"), /*#__PURE__*/React.createElement(Progress, {
    values: [total.commitsPushed / (totalSum || 1) * 100, total.prsCreated / (totalSum || 1) * 100, total.prComments / (totalSum || 1) * 100, total.prsReviewed / (totalSum || 1) * 100, total.prsMerged / (totalSum || 1) * 100],
    height: 2,
    labels: [`Commited: ${total.commitsPushed}`, `Created PRs: ${total.prsCreated}`, `PR Comments: ${total.prComments}`, `PRs Reviewed: ${total.prsReviewed}`, `PRs Merged: ${total.prsMerged}`],
    colors: ["#9fadbc", "#85b8ff", "#A0D7E7", "#d293eb", "#7de2b8"]
  }), /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    fontSize: 3
  }, totalSum), repositories.slice(0, 3).map(repository => cardItem(repository))), repositories.length > 3 && /*#__PURE__*/React.createElement(Box, {
    justify: "end",
    s: {
      mt: 3
    }
  }, /*#__PURE__*/React.createElement(Link, {
    color: "primary",
    fontSize: 4,
    onClick: () => setOpen(true)
  }, "See all", /*#__PURE__*/React.createElement(Icon, {
    src: "arrow",
    s: {
      ml: 1,
      mt: -0.5
    }
  }))), /*#__PURE__*/React.createElement(InfoButton, {
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": "Info",
    color: "translucentPrimary",
    display: "inline",
    fontSize: 3,
    lineHeight: 3,
    s: {
      p: 1,
      ml: 2
    },
    outline: false,
    rounded: true
  }, /*#__PURE__*/React.createElement(Icon, {
    scale: 4,
    src: "infoOutline"
  })), /*#__PURE__*/React.createElement(Modal, {
    open: open
  }, /*#__PURE__*/React.createElement(Modal.Body, {
    title: "Repositories",
    onClose: () => setOpen(false),
    maxWidth: "600px",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement(Grid, {
    cols: 3,
    template: "minmax(140px, auto) minmax(100px, 100%) 1rem",
    align: "center",
    gap: 3
  }, repositories.map(item => cardItem(item)))))));
};
export default RepositoriesCard;